import { RootState } from '../../store/root-state';
import { Projects } from './projects';

/**
 * The slice holds every project the user can open, archived ones included -- an archived project
 * is still reachable, in a view-only mode, by anyone who could open it before it was archived.
 *
 * Only the project selector wants that whole list. Everywhere else -- the dashboards, the
 * calendar, search, the email filters -- is about work in flight, and an archived project has
 * none, so the default selector keeps returning active projects exactly as it did when the fetch
 * itself dropped them.
 *
 * The filtered array is memoized on the slice's identity because `useSelector` compares by
 * reference: a fresh `filter()` on every call would re-render every one of those consumers on
 * every dispatch in the app.
 */
let lastProjects: Projects | undefined;
let lastActiveProjects: Projects = [];

const getProjectsState = (state: RootState): Projects => {
  const projects = state.projects.projects;
  if (projects !== lastProjects) {
    lastProjects = projects;
    lastActiveProjects = projects.filter((project) => !project.isArchived);
  }
  return lastActiveProjects;
};

/** Every project the user can open, archived (view-only) ones included. */
export const getAllProjectsIncludingArchivedState = (state: RootState): Projects =>
  state.projects.projects;

export default getProjectsState;
